import { List, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavItem } from '../styles/navItem';
import { IconImage, IconNestedListItemImage } from '../iconImage';
import {
    ADMIN_ACCOUNT_ROUTE,
    BRANCH_ROUTE,
    CATEGORY_MERCHANT_ROUTE,
    COUPON_ROUTE,
    DRIVER_FINANCIAL_CLEARANCE_ROUTE,
    DRIVER_ROUTE,
    HOME_ROUTE,
    ORDER_ROUTE,
    PRODUCT_MERCHANT_ROUTE,
    PROMOTION_ROUTE,
    STAFF_ROUTE,
    FORM_DRIVER_REGISTER,
    RIDER_REPORT,
    COUPON_HISTORY,
    RIDER_BALANCE,
    SALES_REPORT_ROUTE,
} from '../../../routes/paths';
import DASHBOARD_ICON from '../../../assets/images/drawer_icons/dashboard_icon.svg';
import order_ic from '../../../assets/images/dashboard/order_ic.svg';
import admin_ic from '../../../assets/images/dashboard/admin_ic.svg';
import jiffy_merchant_ic from '../../../assets/images/drawer_icons/jiffy_merchant.svg';
import nested_list_item_ic from '../../../assets/images/drawer_icons/nested_list_item.svg';
import driver_ic from '../../../assets/images/drawer_icons/driver.svg';
import coupon_ic from '../../../assets/images/drawer_icons/coupon.svg';
import report_ic from '../../../assets/images/dashboard/report_ic.svg'
import { NestedListItem } from '../styles/navListItem';

const AdminNavbar = () => {
    const { t } = useTranslation("global");

    return (
        <List disablePadding sx={{ p: 1, paddingBottom: 10 }}>
            <Typography sx={{ mb: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.GENERAL")}</Typography>
            <NavItem title={t("navbar.Dashboard")} path={HOME_ROUTE} icon={<IconImage imageUrl={DASHBOARD_ICON} />} />
            <NavItem title={t("navbar.Order Management")} path={ORDER_ROUTE} icon={<IconImage imageUrl={order_ic} />} />

            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.REPORT")}</Typography>
            <NavItem title={t("navbar.All Report")} path={SALES_REPORT_ROUTE} icon={<IconImage imageUrl={report_ic} />} />
            <NavItem title={t("navbar.Rider Report")} path={RIDER_REPORT} icon={<IconImage imageUrl={driver_ic} />} />
            <NavItem title={t("navbar.Coupon Report")} path={COUPON_HISTORY} icon={<IconImage imageUrl={coupon_ic} />} />

            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.MANAGEMENT")}</Typography>
            <NavItem title={t("navbar.Admin Account")} path={ADMIN_ACCOUNT_ROUTE} icon={<IconImage imageUrl={admin_ic} />} />
            <NestedListItem nestedValue={t("navbar.Merchant")} iconSrc={jiffy_merchant_ic} listItems={[
                <NavItem title={t("navbar.Merchant User")} path={STAFF_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem title={t("navbar.Branch")} path={BRANCH_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem title={t("navbar.Product Merchant")} path={PRODUCT_MERCHANT_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem title={t("navbar.Category Merchant")} path={CATEGORY_MERCHANT_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            ]} />
            <NestedListItem nestedValue={t('navbar.Driver')} iconSrc={driver_ic} listItems={[
                <NavItem title={t("navbar.All Driver")} path={DRIVER_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem title={t("navbar.Driver Form Register")} path={FORM_DRIVER_REGISTER} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                // <NavItem title={"Driver bonus"} path={DRIVER_BONUS_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            ]} />

            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.ACCOUNTING")}</Typography>
            <NavItem title={t("navbar.Clearance Money Rider")} path={RIDER_BALANCE} icon={<IconImage imageUrl={driver_ic} />} />
            <NavItem title={t("navbar.Payment Money Rider")} path={DRIVER_FINANCIAL_CLEARANCE_ROUTE} icon={<IconImage imageUrl={driver_ic} />} />


            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.MARKETING")}</Typography>
            <NavItem title={t("navbar.Promotion")} path={PROMOTION_ROUTE} icon={<IconImage imageUrl={jiffy_merchant_ic} />} />
            <NavItem title={t("navbar.Coupon Management")} path={COUPON_ROUTE} icon={<IconImage imageUrl={coupon_ic} />} />
        </List>
    )
}

export default AdminNavbar